import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import constants from 'scoreboard/components/constants'
import reportConstants from 'scoreboard/reports/report-constants'
import ScorecardReportModel from 'scoreboard/reports/scorecard-report/scorecard-report-model'
import projects from 'scoreboard/projects/projects'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

const optionList = _.memoize(function() {
	const baseOptions = _.cloneDeep(constants.initiativeReportColumnTypes)
	return _.sortBy(_.values(baseOptions), val => i18n.get(val.label))
})

function calendarPeriodOption() {
	return {
		id: 'initiative-calendar-period',
		label: 'common.calendar.calendarPeriod',
		icon: 'calendar',
		dataType: DATE,
		changesOverTime: true
	}
}

function calendarPeriodBreakdownAttributes() {
	return {range: ScorecardReportModel.defaultRange()}
}

const defaultColumnDataMap = _.memoize(function() {
	let columnDataByColumnType = _.cloneDeep(constants.initiativeReportColumnTypes)
	_.each(columnDataByColumnType, (columnData, columnType) => {
		delete columnData.id
		columnData.columnType = columnType
		columnData.style = {}
		columnData.aggregationType = columnData.defaultAggregationType
		columnData.abbreviated = true
	})
	return columnDataByColumnType
})

const InitiativeReportModel = ScorecardReportModel.extend({

	allowTemplate: false,
	designer: true,
	reportDomainType: 'initiative',

	defaults() {
		return _.extend({
			subtype: 'initiative-report-designer',
			filters: {
				projectIds: [{values:[projects.id]}]
			},
			structure: {
				stacks: [
					this._defaultStackData('label', {sortType: 'tree'}),
					this._defaultStackData('assignees'),
					this._defaultStackData('budget-variance'),
					this._defaultStackData('schedule-variance')
				]
			}
		}, this._defaultProperties())
	},

	validate(attrs = this.attributes, opts = {}) {
		let errors = {}
		if (_.isEmpty(attrs.label)) {
			errors.label = i18n.get('common.error.required', i18n.get('report.title'))
		}
		return this.formatErrors(errors, opts)
	},

	/**
	 * Returns an array of option data for the given column
	 */
	nonRepeatByColumnOptionsList: function(reportColumnModel, opts = {}) {
		return optionList()
	},

	repeatByColumnOptionsList: function(stack, opts) {
		let data = _.filter(this.columnDataByFieldIdOrColumnType(), (columnData) => {
			return columnData.canRepeatBy
		})
		if (this.isAggregating() && _.isEmpty(stack.breakdowns())) {
			//include by calendar period option #42410
			let periodOption = calendarPeriodOption()
			data.push(periodOption)
		}
		return data
	},

	columnDataByFieldIdOrColumnType: function(typeId) {
		let periodOption = calendarPeriodOption()
		if (typeId == periodOption.id) {
			return periodOption
		}
		return ScorecardReportModel.prototype.columnDataByFieldIdOrColumnType.apply(this, arguments)
	},

	_defaultStackData: function(columnType, overrides = {}) {
		let stack = {columns: []}
		if (_.isArray(columnType)) {
			_.each(columnType, cti => {
				let s = this._defaultStackData(cti, overrides)
				stack.columns = stack.columns.concat(s.columns)
			})
		} else {
			stack.columns.push(this._defaultColumnData(columnType, overrides))
		}
		return stack
	},

	_columnDataMap: function() {
		return _.cloneDeep(constants.initiativeReportColumnTypes)
	},

	/**
	 * Generates the default column data for a given column type
	 */
	_defaultColumnData: function(columnType, overrides = {}) {
		let columnData = defaultColumnDataMap()[columnType]
		//initiative notes always show everything
		if (columnType == reportConstants.REPORT_COLUMN_NOTES_COLUMN_TYPE_ID) {
			columnData.noteDisplayOptions = {
				displayType: reportConstants.NOTE_DISPLAY_TYPE_ALL,
				displayProperties : {
					'createdDate' : true,
					'author': true,
					'replies': true,
					'appliesTo': true,
					'domainLabel': true
				}
			}
		}
		return _.defaults(overrides, columnData)
	},

	defaultBreakdownDataByFieldIdOrColumnType: function(fieldIdOrColumnType) {
		if (fieldIdOrColumnType == calendarPeriodOption().id) {
			//breaking down by calendar period
			return calendarPeriodBreakdownAttributes()
		}
		return { breakdownBy: fieldIdOrColumnType }
	}

})

export default InitiativeReportModel

InitiativeReportModel.__filename__ = 'reports/initiative-report/initiative-report-model.js'
